import { Box, Flex, HStack } from '@chakra-ui/react'
import Header from '../components/Header'
import { NavigationBar } from '../components/NavigationBar'
import { Editor } from '../components/editorView/Editor'
import { useRoomMetadata } from '../hooks/useRoomMetadata'
import { RoomMetadata } from '../auto-generated-clients/content-delivery-client-v3.generated'
import { useEffect, useState } from 'react'
import { useCompanyData } from '../hooks/useCompanyData'
import { Company } from '../auto-generated-clients/companydata-client-v2.generated'

const Home = () => {
  const [selectedCompany, setSelectedCompany] = useState<Company | undefined>()
  const [selectedRoom, setSelectedRoom] = useState<RoomMetadata | undefined>()

  const [companySearch, setCompanySearch] = useState<string>('')
  const [roomSearch, setRoomSearch] = useState<string>('')
 
  const { data: companies } = useCompanyData(companySearch)
  const {
    data: rooms,
    isLoading: isRoomsLoading,
    error,
  } = useRoomMetadata(roomSearch, selectedCompany?.companyId)

  const filteredRooms = rooms?.filter((r) => r.isVisibleInMenu)

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedCompany) {
      setRoomSearch(e.target.value)
    } else {
      setCompanySearch(e.target.value)
    }
  }

  const resetSearch = () => {
    setCompanySearch('')
    setRoomSearch('')
  }

  useEffect(() => {
    if (error && JSON.stringify(error).includes('403')) {
      alert(
        'It seems like you are not authorized to view this page. Please contact support.'
      )
    }
  }, [error])

  return (
    <Box scrollbarGutter='stable'>
      <Header />
      <HStack height={'calc(100vh - 84px)'} width={'100%'} gap={0}>
        <NavigationBar
          companies={companies}
          rooms={filteredRooms}
          selectedRoom={selectedRoom}
          setSelectedRoom={setSelectedRoom}
          handleSearch={handleSearch}
          selectedCompany={selectedCompany}
          setSelectedCompany={setSelectedCompany}
          resetSearch={resetSearch}
          isLoading={isRoomsLoading}
        />
        <Flex
          boxSize={'full'}
          alignItems={'flex-start'}
          justifyContent={'center'}>
          <Editor selectedRoom={selectedRoom} />
        </Flex>
      </HStack>
    </Box>
  )
}

export default Home
